import { requestHttp } from "../utils/HttpRequest";

export const getSellerSalesCustomersProductsMetrics = (idUser, date,idr) => {
  try {
    const response = requestHttp({
      endpoint: "seller_customers_products",
      data: {
        user_id: idUser,
        chosen_date: date,
        idr:idr,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
